<template>
  <div class="instrument-package-list">
    <div class="search-line">
      <div class="left">
        <!-- 器械包名称或拼音码 -->
        <el-input v-model="queryParams.name" class="input200 mr10" :placeholder="`器械包`" clearable></el-input>
        <!-- 请输入包刻码 -->
        <!-- <el-input v-model="queryParams.inner_code" class="input200 ml10" :placeholder="`编码`" clearable></el-input> -->
        <!-- 请输入器械名称 -->
        <!-- <el-select
            class="input200 mr10"
            v-model="queryParams.instrument_id" 
            filterable
            clearable
            remote
            reserve-keyword
            :placeholder="`器械`"
            :remote-method="searchInstruments"
            @focus="searchInstruments('')">
          <el-option
            v-for="item in instrumentsOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select> -->
        <!-- 请输入科室名称/拼音 -->
        <el-autocomplete
            class="search-input mr10"
            v-model="queryParams.department_name"
            :fetch-suggestions="getDep"
            value-key="name"
            clearable
            :placeholder="`科室`"
          ></el-autocomplete>
          <!-- 请选择包装方式 -->
        <el-select v-model="queryParams.pack_option" class="input200 mr10" :placeholder="`包装方式`">
          <!-- 全部 -->
          <el-option :label="`全部`" value=""></el-option>
          <el-option
            v-for="item in packageOptions"
            :key="item.id"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
        <!-- 包装规格 -->
        <el-select v-model="queryParams.group2" class="input200 mr10" :placeholder="`包装规格`">
          <!-- 全部 -->
          <el-option :label="`全部`" value=""></el-option>
          <el-option
            v-for="item in dsinstrumentset_pack_spec"
            :key="item.id"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>

        <!-- 请选择处理方式 -->
        <el-select v-model="queryParams.sterilization_option" class="input200 mr10" :placeholder="`处理方式`">
          <!-- 全部 -->
          <el-option :label="`全部`" value=""></el-option>
          <el-option
            v-for="item in dealOptions"
            :key="item.id"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
        <!-- 请选择包类型 -->
        <el-select v-model="queryParams.type_option" class="input200 mr10" :placeholder="`类型`">
          <!-- 全部 -->
          <el-option :label="`全部`" value=""></el-option>
          <el-option
                  v-for="item in typeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value">
          </el-option>
        </el-select>
        <!-- 请选择库存位置 -->
        <!-- <el-select v-model="queryParams.warehouse_id" multiple class="input200 ml10" :placeholder="`库存位置`">
          <el-option
            v-for="item in wareHouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
        <!-- 请选择厂家名称 -->
        <!-- <el-select v-model="queryParams.vendor_id" clearable class="input200 ml10" :placeholder="`厂家`" remote :remote-method="getVendors" filterable>
          <el-option
            v-for="item in vendorList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select> -->
        <!-- 是否为长租外来器械 -->
        <el-select v-model="queryParams.is_short_term" class="input200 mr10" :placeholder="`外来器械`">
          <!-- 全部 -->
          <!-- 是 -->
          <!-- 否 -->
          <el-option :label="`全部`" value=""></el-option>
          <el-option :label="`是`" value="1"></el-option>
          <el-option :label="`否`" value="0"></el-option>
        </el-select>
        <!-- 请选择分组 -->
        <!-- <el-select class="input150 ml10" v-model="queryParams.group4" :placeholder="`分组`" clearable>
            <el-option
              v-for="item in groupOptions"
              :key="item.id"
              :label="item.name"
              :value="item.value">
            </el-option>
            <el-option :key="0" :value="0" :label="`其他`"></el-option>
          </el-select> -->
          <!-- 请选择状态 -->
        <el-select class="input200" v-model="queryParams.status" clearable :placeholder="`状态`">
          <el-option
            v-for="(value, name) in accoutStatus"
            :key="name"
            :label="value"
            :value="name">
          </el-option>
        </el-select>
        <!-- 查询 -->
        <el-button icon="el-icon-search" class="mt10 ml10" size="mini" type="primary" @click.prevent="search()">查询</el-button>
        <!-- 导入 -->
        <el-button type="primary" icon="el-icon-upload2" size="mini" @click="importList(1)">导入</el-button>
        <!-- 导入基数 -->
        <!-- <el-button type="primary" icon="el-icon-upload2" size="mini" @click="importList(2)">导入基数</el-button> -->
        <!-- 导出清单 -->
        <el-button class="mt10 ml10" size="mini" type="primary" @click.prevent="exportFile('list')">导出清单</el-button>
        <!-- 新建 -->
        <el-button v-if="btnauth[$route.path].includes('package_new_button')" class="mt10 ml10" size="mini" type="primary" icon="el-icon-plus" @click.prevent="goNew()">新建</el-button>
        <!-- 批量删除 -->
        <el-button class="mt10 ml10" size="mini" type="primary" icon="el-icon-delete" @click.prevent="batchDelete()">批量删除</el-button>
      </div>
      <div class="right">
        <table-header-editor :headers="tableHeaders" class="table-header-editor" />
      </div>
    </div>
    <div class="page-card">
      <el-table
        ref="list"
        :data="list"
        :header-cell-class-name="'table-header-cell'"
        @sort-change="sortChange"
        border
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          v-for="(item) in tableHeaders"
          :key="item.id"
          :type="item.type"
          :label="item.label"
          :prop="item.prop"
          :sortable="!!item.sortKey ? 'custom': false"
          :sort-by="item.sortKey"
          :width="item.width">
            <template slot-scope="scope">
              <span v-if="item.type ==='index'">{{scope.$index + 1}}</span>
              <span v-else-if="item.prop === 'image'" class="pic-wrap">
                <span class="list-pic" v-for="(img) in scope.row.image" :key="img.id">
                  <el-image :src="img.url" :preview-src-list="scope.row.image.map(i => i.url)"></el-image>
                </span>
              </span>
              <span v-else-if="item.handle">
                <!-- 编辑 -->
                <el-tooltip effect="dark" :content="`编辑`" placement="top-start">
                  <el-button class="p0 fontsize20" type="text" @click.prevent="goEdit(scope.row.id)"><i class="el-icon-edit-outline"></i></el-button>
                </el-tooltip>
                <!-- 停用 -->
                <el-tooltip effect="dark" :content="`停用`" placement="top-start" v-if="scope.row.status === 0 && btnauth[$route.path].includes('package_disable_button')">
                  <el-button class="p0 fontsize20" type="text" @click.prevent="goDeprecate(scope.row.id)"><i class="el-icon-circle-close"></i></el-button>
                </el-tooltip>
                <!-- 恢复 -->
                <el-tooltip effect="dark" :content="`恢复`" placement="top-start" v-if="scope.row.status == 3">
                  <el-button class="p0 fontsize20" type="text" @click.prevent="goRestore(scope.row.id)"><i class="el-icon-refresh"></i></el-button>
                </el-tooltip>
                <!-- 删除 -->
                <el-tooltip effect="dark" :content="`删除`" placement="top-start" v-if="scope.row.status === 3 && btnauth[$route.path].includes('package_delete_button')">
                  <el-button class="p0 fontsize20" type="text" @click.prevent="goDelete(scope.row.id)"><i class="el-icon-delete"></i></el-button>
                </el-tooltip>
              </span>
              <span v-else-if="item.prop === 'department_name'">
                <!-- 请选择科室 -->
                <el-select 
                  v-if="isUpData && (user.department_center.id === user.department_data.id)"
                  v-model="scope.row.department_id"
                  filterable
                  clearable
                  remote
                  reserve-keyword
                  :placeholder="`科室`"
                  :remote-method="searchDept"
                  @focus="searchDept('')">
                  <el-option
                    v-for="item in deptOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <span v-else>{{ scope.row.department_name }}</span>
              </span>
              <span v-else-if="item.prop === 'pack_option_name'">
                <el-select v-if="isUpData && (user.department_data.id === scope.row.department_id || (user.department_center.id === user.department_data.id))" v-model="scope.row.pack_option" clearable >
                  <el-option
                    v-for="item in packageOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
                <span v-else>{{ scope.row.pack_option_name }}</span>
              </span>
              <span v-else-if="item.prop === 'sterilization_option_name'">
                <el-select v-if="isUpData && (user.department_data.id === scope.row.department_id || (user.department_center.id === user.department_data.id))" v-model="scope.row.sterilization_option" clearable >
                  <el-option
                    v-for="item in dealOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
                <span v-else>{{ scope.row.sterilization_option_name }}</span>
              </span>
              <span v-else-if="item.prop === 'cost'">
                <el-input-number v-if="isUpData && (user.department_data.id === scope.row.department_id || (user.department_center.id === user.department_data.id))" size="small" v-model="scope.row.cost" controls-position="right"></el-input-number>
                <span v-else>{{ scope.row.cost }}</span>
              </span>
              <span v-else>{{scope.row[item.prop]}}</span>
            </template>
        </el-table-column>
      </el-table>
      <pagination :queryParams="queryParams" :getList="getList" />
    </div>
    <ImportFile :link="fileName" ref="importFile" @complete="getImport"/>
    
    <!-- 附件上传 -->
    <multi-file-upload ref="MultiFileUpload" :type="'*'" :limit="1" @complete="getFiles" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Pagination from '@/components/common/Pagination.vue'
import TableHeaderEditor from '@/components/common/TableHeaderEditor.vue'
import ImportFile from '@/components/common/ImportFile.vue'
import MultiFileUpload from '@/components/common/MultiFileUpload.vue'
import { instrumentPackage, instrumentPackageDelete,instrumentOptions, instrumentPackageRestore, instrumentPackageDeprecate, departmentOptions, instrumentPackageExport, instrumentCodePackageExport, instrumentPackageImport, baseImport,packagePull, getWareHouseList, vendorOptions, instrumentEditColumns,uploadBatch, instrumentPackageBatchDelete } from '@/api.js'
import { pageSize } from '@/utils/Config.js'
export default {
  name: 'InstrumentPackage',
  components: {
    Pagination,
    TableHeaderEditor,
    ImportFile,
    MultiFileUpload
  },
  computed: {
      ...mapGetters(['exec', 'btnauth', 'user'])
    },
  data() {
    return {
      fileName:'',
      uploadType:'',
      queryParams: {
        name: '',
        pageIndex: 1,
        pageSize,
        _total: 0,
        status: '0',
      },
      tableHeaders: [],
      depOptions: [],
      packageOptions: [],
      dealOptions: [],
      typeOptions: [],
      list: [],
      importLoading: null,
      importBaseLoading:null,
      wareHouseList: [],
      vendorList: [],
      groupOptions: [],
      instrumentsOptions:[],
      accoutStatus: {
        // 启用
        0: `启用`,
        // 停用
        1: `禁用`
      },
      isUpData: false,
      deptOptions: [],
      packOption: [],
      dsinstrumentset_pack_spec: [],
    }
  },
  async created() {
    await Promise.all([this.getOptions(), this.getDepartmentOptions(), this.searchDept()])
    this.getList()
    this.listenSocket()
  },
  methods: {
    async listenSocket() {
      // 监听socket
      const socket = await this.$socket()
      socket.on('import_instrumentset', (data) => {
        if (data) {
          const jsonData = JSON.parse(data)
          if (jsonData.code === 200) {
            if (this.importLoading) {
              this.importLoading.close()
            }

            this.$message.success(`成功`)
            this.getList()
          } else {
            if (this.importLoading) {
              this.importLoading.close()
              this.importLoading = null
            }
            this.$message.error(jsonData.msg)
          }
        }
      })

      socket.on('import_base', (data) => {
        if (data) {
          const jsonData = JSON.parse(data)
          if (jsonData.code === 200) {
            if (this.importBaseLoading) {
              this.importBaseLoading.close()
            }
            this.$message.success(`成功`)
            this.getList()
          } else {
            if (this.importBaseLoading) {
              this.importBaseLoading.close()
              this.importBaseLoading = null
            }
            this.$message.error(jsonData.msg)
          }
        }
      })
    },
    getOptions() {
      // 获取包装方式、处理方式
      return this.$utils.getDict([338, 5 ,314, 70,150]).then((res) => {
        if (res) {
          this.packageOptions = res[5]
          this.dealOptions = res[338]
          this.typeOptions = res[314]
          this.groupOptions = res[70]
          this.dsinstrumentset_pack_spec = res[150]
        }
      })
    },
    searchInstruments(query){
        const params = {
            name: query || ''
        }
        const url = instrumentOptions
        this.$request('get', url, params).then(res=>{
            this.instrumentsOptions = res;
        })
    },
    getDep(query, cb) {
      // 查询科室
      const params = {
        name: query || ''
      }
      this.$request('get', departmentOptions, params)
      .then((res) => {
        if (res) {
          this.depOptions = res

          if (cb) {
            cb(res)
          }
        }
      })
    },
    importList(type) {
      if(type==1){
        // 器械包管理
        this.fileName ='/template/basic/instrumentset/'+`器械包管理`+'.xlsx';
        this.uploadType=1
      }else{
        // 基数
        this.fileName ='/template/basic/instrumentset/'+`基数`+'.xlsx';
        this.uploadType = 2
      }
      // 开始导入
      this.$refs.importFile.show()
    },

    getImport(file) {
       if(this.uploadType==1){
         // 接收导入文件信息
         const info = {
           file_id: file.fileId
         }
         this.$request('post', instrumentPackageImport, info)
                 .then((res) => {
                   if (res) {
                     this.$message.success(`操作成功`)
                     this.getList()

                     
                    //  this.importLoading = this.importLoading || this.$loading({
                    //    lock: true,
                    //     //  导入中
                    //    text: `导入中...`,
                    //    spinner: 'el-icon-loading',
                    //    background: 'rgba(0, 0, 0, 0.7)'
                    //  })
                   }
                 })
       }else if(this.uploadType==2){
         //导入基数
         const info = {
           file_id: file.fileId
         }
         this.$request('post', baseImport, info)
                 .then((res) => {
                   if (res) {
                    this.$message.success(`操作成功`)
                     this.getList()

                    //  this.importLoading = this.importLoading || this.$loading({
                    //    lock: true,
                    //    text: `导入中...`,
                    //    spinner: 'el-icon-loading',
                    //    background: 'rgba(0, 0, 0, 0.7)'
                    //  })
                   }
                 })
       }
      },

    getDepartmentOptions() {
      // 获取科室
      return this.$request('get', departmentOptions, { with_center: 0, with_deleted: 0 })
      .then((res) => {
        if (res) {
          this.depOptions = res
        }
      })
    },
    search() {
      this.queryParams.pageIndex = 1
      this.getList()
    },
    // 同步数据
    pullData() {
      this.$request('post', packagePull)
      .then((res) => {
        if (res) {
          this.$message.success(`成功`)
          this.getList()
        }
      })
    },
    async getList() {
      const url = instrumentPackage
      // console.log(this.depOptions)
      var department_id =''
      for (let i = 0; i < this.depOptions.length; i++) {
        if(this.depOptions[i].name == this.queryParams.department_name){
          department_id = this.depOptions[i].id
        }
      }
      const {
        pageIndex,
        pageSize,
        name,
        sterilization_option,
        pack_option,
        type_option,
        orderBy,
        order,
        warehouse_id,
        vendor_id,
        is_short_term,
        inner_code,
        group4,
        group2,
        status,
        instrument_id
      } = this.queryParams
      const queryParams = {
        page: pageIndex,
        per_page: pageSize,
        name: name.trim(),
        department_id: department_id,
        sterilization_option,
        pack_option,
        type_option,
        order_column: orderBy,
        order,
        warehouse_id,
        vendor_id,
        is_short_term,
        inner_code,
        group4,
        group2,
        status,
        instrument_id
      }
      const res = await this.$request('get', url, queryParams)
      if (res) {
        const prev = [
          {
            width: 60,
            label: '#',
            prop: '',
            type: 'index',
            checked: true
          }
        ]
        const last = [
          {
            // 操作
            width: 'auto',
            label: `操作`,
            prop: '',
            checked: true,
            handle: true
          }
        ]

        this.tableHeaders = this.tableHeaders.length > 0 ? this.tableHeaders : this.$utils.generateColumns(res.columns, prev, last)
        this.list = res.data
        this.queryParams._total = res.total
      }
    },
    exportFile(type) {
      // 导出功能
      let url = ''
      let params = {}
      var department_id =''
      for (let i = 0; i < this.depOptions.length; i++) {
        if(this.depOptions[i].name == this.queryParams.department_name){
          department_id = this.depOptions[i].id
        }
      }
      const {
        name, sterilization_option, pack_option ,type_option,group2
      } = this.queryParams
      if (type === 'list') {
        url = instrumentPackageExport
        params = {
          name,
          department_id : department_id,
          sterilization_option,
          pack_option,
          type_option,
          group2
        }
      } else if (type === 'package') {
        url = instrumentCodePackageExport
        params = {
          name,
          department_id : department_id,
          sterilization_option,
          pack_option,
          type_option,
          group2
        }
      }

      this.$utils.exportFile(url, params)
    },
    goNew() {
      this.$router.push('/basic/instrument-package/edit/0')
    },
    goEdit(id) {
      const url = `${window.location.origin}${this.$utils.siteBase()}basic/instrument-package/edit/${id || 0}`

      window.open(url, '_blank')
    },
    goRestore(id) {
      // 确认恢复吗？
      this.$confirm(`确认恢复吗？`,{
          type: 'warning',
          // 确定
          confirmButtonText: `确定`,
          // 取消
          cancelButtonText: `取消`,
        })
      .then(async () => {
        const url = instrumentPackageRestore.replace('{id}', id)
        const res = await this.$request('post', url, {})
        if (`${res}`) {
          this.$message.success(`成功`)
          this.getList()
        }
      })
    },
    goDeprecate(id) {
      // 确认停用吗？
      this.$confirm(`确定停用吗`,{
          type: 'warning',
          // 确定
          confirmButtonText: `确定`,
          // 取消
          cancelButtonText: `取消`,
        })
      .then(async () => {
        const url = instrumentPackageDeprecate.replace('{id}', id)
        const res = await this.$request('post', url, {})
        if (`${res}`) {
          this.$message.success(`成功`)
          this.getList()
        }
      })
    },
    async batchDelete() {
      // 批量删除
      const { list } = this.$refs
      const { selection } = list
      if (!selection || !selection.length) {
        this.$message.error(`请选择需要删除的数据`)

        return
      }

      const c = await this.$utils.confirm({ msg: `确认删除吗?` })
      if (!c) return
      
      const ids = selection.map(i => i.id)
      this.$request('post', instrumentPackageBatchDelete, { ids })
      .then(res => {
        if (res) {
          this.$message.success(`删除成功`)

          this.getList()
        }
      })
    },
    goDelete(id) {
      // 确定删除吗
      this.$confirm(`确认删除吗?`,{
        type: 'warning',
        // 确定
        confirmButtonText: `确定`,
        // 取消
        cancelButtonText: `取消`,
      })
      .then(async () => {
        const url =instrumentPackageDelete.replace('{id}', id)
        const res = await this.$request('post', url, {})
        if (`${res}`) {
          this.$message.success(`删除成功`)

          this.getList()
        }
      })
    },
    sortChange(item) {
      // 排序方法
      const { column, order } = item
      const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
      const orderBy = order ? column.sortBy : undefined

      this.queryParams.order = orderString
      this.queryParams.orderBy = orderBy
      this.getList()
    },
    getWareHouse() {
      this.$request('get', getWareHouseList, {})
      .then((res) => {
        if (res) {
          this.wareHouseList = res
        }
      })
    },
    getVendors(query, cb) {
      const params = {
        name: query || '',
        type: 2
      }
      this.$request('get', vendorOptions, params)
      .then((res) => {
        this.vendorList = res
        if (cb) {
            cb(res)
          }
      })
    },
    searchDept(query){
      const params = {
        name: query || '',
        with_out: 1,
      }
      const url = departmentOptions
      this.$request('get', url, params).then(res=>{
        this.deptOptions = res;
      })
    },
    listUpDataSave() {
      const instrumentset_data = this.list.map((item) => {
        const query = {
          instrumentset_id: item.id,
          department_id: item.department_id,
          pack_option: item.pack_option,
          sterilization_option: item.sterilization_option,
          cost: item.cost,
        }
        return query
      })
      this.$request('post', instrumentEditColumns, {instrumentset_data})
      .then((res) => {
        if (res) {
          this.isUpData = false
          this.search()
          this.$message.success(`成功`)
        }
      })
      
    },
    
    uploadFile() {
        // 上传附件
        const { MultiFileUpload } = this.$refs
        MultiFileUpload && MultiFileUpload.open()
    },
    getFiles(files) {
      // 绑定文件
      const file_ids = files.map(i => i.fileId)
      const params = {
        file_ids,
      }
      this.$request('post', uploadBatch, params)
      .then(res => {
        if (res) {
          this.$message.warning(res)
        }else{
          this.$message.success(`上传成功`)
          this.getList()
        }
      })
    },
  }
}
</script>

<style>

</style>